exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".build-bill-container[data-v-e535856c]{display:inline;margin-left:10px;text-align:left}.build-bill-container .bill-range-tips[data-v-e535856c]{color:#909399}.build-bill-container .bill-range-tips.error[data-v-e535856c]{color:#F56C6C}.build-bill-form-dialog .el-form-item[data-v-e535856c]{margin-bottom:12px}.build-bill-form-dialog .bill-tips[data-v-e535856c]{color:#909399}.build-bill-form-dialog .bill-tips.error[data-v-e535856c]{color:#F56C6C}.build-bill-form-dialog .error-num[data-v-e535856c]{color:#F56C6C}\n", ""]);

// exports
